export default "__VITE_ASSET__CjDfUEhv__"